// Shared by the two surfaces that can delete a client scan record (TYR-219):
// the row on the client scans list and the header of the scan page.

// Mirrors LeadDeleteOutcome in lead.service.ts.
export type DeleteOutcome = 'removed' | 'tombstoned' | 'already-deleted';

// Mirrors DeletedLead in lead.service.ts: the approval record and nothing else.
export type DeletedLead = {
  id: string;
  email: string;
  consentVersion: string | null;
  consentIp: string | null;
  consentAt: number | null;
  approvedByUsername: string | null;
  approvedByOrgId: string | null;
  deletedAt: number;
};

// What the owner types to arm the delete: the company, or a plain word when
// the record carries none.
export function confirmWordFor(lead: { company: string }): string {
  return lead.company.trim() || 'delete';
}

// The line the list shows afterwards. It names the outcome the server chose,
// never the one the page assumed.
export function deleteRecordNotice(outcome: DeleteOutcome): string {
  if (outcome === 'removed') {
    return 'Record deleted. It was never approved, so nothing was kept.';
  }
  if (outcome === 'already-deleted') {
    return 'That record was already deleted. Nothing changed.';
  }
  return 'Record deleted. The approval record was kept as evidence that the scan was authorised.';
}
